import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "list-inline list-unstyled" }
const _hoisted_2 = {
  key: 0,
  class: "fas fa-spinner fa-spin align-text-bottom me-1"
}
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", null, [
    _createElementVNode("ul", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("li", { class: "list-inline-item me-0" }, [
        _createElementVNode("i", { class: "fas fa-user-circle fa-lg align-text-bottom" })
      ], -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamBreadcrumbs, (user) => {
        return (_openBlock(), _createElementBlock("li", {
          key: user,
          class: "list-inline-item me-1"
        }, [
          _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fas fa-chevron-right fa-fw fa-sm align-text-bottom" }, null, -1)),
          (
            user === _ctx.teamBreadcrumbs[_ctx.teamBreadcrumbs.length - 1] && _ctx.isLoading
          )
            ? (_openBlock(), _createElementBlock("i", _hoisted_2))
            : _createCommentVNode("", true),
          _createElementVNode("a", {
            role: "button",
            href: "#",
            class: "link-secondary",
            onClick: ($event: any) => (_ctx.showUserTeam(user))
          }, _toDisplayString(user), 9, _hoisted_3)
        ]))
      }), 128))
    ])
  ]))
}